import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  min-height: 100vh;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
`;
